import * as React from "react";
import { PlaceholderProps } from "react-select/src/components/Placeholder";
import { Omit } from "@material-ui/types";
import Typography from "@material-ui/core/Typography";
import { IOption } from "constants/types";

const styles = {
    lineHeight: "1",
};

export function Placeholder(props: Partial<Omit<PlaceholderProps<IOption>, "innerProps">>) {
    const { selectProps, innerProps = {}, children } = props;
    return (
        <Typography className={selectProps.classes.placeholder} {...innerProps} style={styles}>
            {children}
        </Typography>
    );
}
